import { localCalendarDayKey } from "../../utils/billingExemptionDailyCache";
import { getUserInfo } from "../../services/localStorage";

const STORAGE_PREFIX = "hr_hotel_cxl_drop_risk_dismiss_v1_";

function storageKey() {
  const email = String(getUserInfo()?.email || "anon").trim().toLowerCase();
  return `${STORAGE_PREFIX}${email}`;
}

export function isHotelCxlDropRiskDismissedToday(now = new Date()) {
  if (typeof window === "undefined") return false;
  try {
    const raw = window.localStorage.getItem(storageKey());
    if (!raw) return false;
    const parsed = JSON.parse(raw);
    return String(parsed?.dayKey || "") === localCalendarDayKey(now);
  } catch {
    return false;
  }
}

export function dismissHotelCxlDropRiskForToday(now = new Date()) {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(
      storageKey(),
      JSON.stringify({ dayKey: localCalendarDayKey(now), at: Date.now() })
    );
  } catch {
    /* quota / private mode */
  }
}
